module.exports = __webpack_public_path__ + "static/receiver-2-homepage-poster-4093370ea98b636429257b3a26f91124.jpg";